export function buildStep6ImageSuiteUrl({ savedListingId, batchJobId } = {}) {
  if (savedListingId) return `/image-suite.html?fromListing=${encodeURIComponent(savedListingId)}`;
  if (batchJobId) return `/image-suite.html?fromBatchJob=${encodeURIComponent(batchJobId)}`;
  return null;
}

export function buildStep6VideoSuiteUrl({ savedListingId } = {}) {
  return savedListingId ? `/video-suite.html?fromListing=${encodeURIComponent(savedListingId)}` : null;
}

export function createRevisionSuiteNavigation({
  getState,
  select,
  ensureAutoSave,
  showToast,
  locationRef = globalThis.location,
}) {
  async function openImageSuiteForCurrentListing() {
    if (getState('browseOnlyListing')) {
      showToast('当前是只读 Listing，请先恢复为可编辑快照再生成图片', true);
      return false;
    }
    const button = select('#step6-enter-suite-btn');
    const originalText = button?.textContent || '🎨 生成图片';
    if (button) { button.disabled = true; button.textContent = '正在绑定 Listing...'; }
    try {
      const saved = await ensureAutoSave(getState('batchJobId'));
      const target = buildStep6ImageSuiteUrl({ savedListingId: saved?.id || getState('savedListingId') });
      if (!target) throw new Error('当前 Listing 尚未保存');
      if (!locationRef) throw new Error('当前环境无法打开套图页面');
      locationRef.href = target;
      return true;
    } catch (error) {
      showToast(`进入套图失败：${error.message || 'Listing 保存失败'}`, true);
      return false;
    } finally {
      if (button) { button.disabled = false; button.textContent = originalText; }
    }
  }
  return { openImageSuiteForCurrentListing };
}
